<template>
  <div class="recharge-page" :class="{ 'gem-mode': activeRechargeType === 'gems' }">
    <header class="mobile-recharge-header">
      <div class="mobile-header-content">
        <div class="mobile-logo-section" @click="goHome">
          <img src="@/img/home/oumiAndName.webp" :alt="$t('header.logoAlt')" class="mobile-logo-icon">
        </div>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <div class="recharge-container">
      <!-- 标题区域 - 在卡片外面 -->
      <!-- <div class="page-header">
        <img src="@/img/recharge/oumi_coin.webp" :alt="$t('recharge.oumiCoin')" class="coin-icon">
        <h1 class="page-title">{{ $t('recharge.oumiTopUp') }}</h1>
      </div> -->

      <RechargeTypeTabs
        class="currency-tabs"
        :active="activeRechargeType"
        compact
        @change="switchRechargeType"
      />

      <!-- 首充提示和账号输入共用一张卡片。 -->
      <div class="input-section-container">
        <aside class="input-section-card">
          <div class="card-copy">
            <div class="card-title">{{ $t('recharge.firstTopUpGift') }}</div>
            <div class="card-description">{{ $t('recharge.firstTopUpGiftDescription') }}</div>
          </div>
          <img src="@/img/recharge/recharge_gift.webp" alt="" class="gift-icon" width="153" height="146">
        </aside>
        <div class="input-section">
          <label class="user-id-title" for="mobile-recharge-user-id">{{ $t('recharge.userId') }}</label>
          <div class="input-wrapper">
            <input 
              id="mobile-recharge-user-id"
              type="text" 
              v-model="user_id" 
              class="user-input" 
              @blur="saveUid" 
              @keyup="checkUid"
              :placeholder="$t('recharge.enterUserIdToTopUp')" 
            />
            <button
              v-if="user_id"
              type="button"
              class="clear-input-button"
              :aria-label="$t('recharge.clearUserId')"
              @mousedown.prevent
              @click="clearUserInput"
            ></button>
          </div>
          
          <!-- 用户信息显示 -->
          <div v-if="user" class="user-info">
            <img :src="user.avatar" class="user-avatar">
            <div class="user-details">
              <div class="user-name">{{ user.nickName }}</div>
              <!-- <div class="user-uid">UID: {{ user.userId }}</div> -->
            </div>
            <div v-if="isNewUser" class="first-top-up">{{ $t('recharge.firstTopUp') }}</div>
          </div>
        </div>
      </div>
      
      <!-- 充值卡片 -->
      <div v-if="showRechargeOptions || rechargeOptionsLoading" class="recharge-card">

        <!-- 金币选择区域 -->
        <div class="amount-section">
          <label class="section-label">{{ $t('recharge.selectTopUpAmount') }}</label>
          <div v-if="rechargeOptionsLoading" class="coin-options" aria-busy="true">
            <div v-for="index in 6" :key="index" class="coin-option option-skeleton"></div>
          </div>
          <div v-else class="coin-options">
            <div 
              v-for="item in recharge_list" 
              :key="item.id"
              class="coin-option"
              :class="{
                active: item.id === select_recharge_id,
                disabled: activeRechargeType === 'gems' && !gemRechargeAllowed,
              }"
              :aria-disabled="activeRechargeType === 'gems' && !gemRechargeAllowed"
              @click="priceChangeHandle(item)"
            >
              <div
                class="coin-amount"
                :class="{ 'coin-amount-long': String(getRechargeAmount(item)).length >= 6 }"
              >
                <img
                  :src="activeRechargeType === 'gems' ? gemIcon : coinIcon"
                  :alt="activeRechargeType === 'gems' ? 'gem' : $t('recharge.coin')"
                  class="coin-icon-small"
                >
                {{ getRechargeAmount(item) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 支付按钮 -->
        <div v-if="showPaymentOptions && !rechargeOptionsLoading" class="payment-section">
          <div v-if="isPhilippineCoinUser" class="ph-coin-top-up-hint">
            {{ $t('recharge.philippineCoinTopUpHint') }}
          </div>
          <button
            v-if="isPhilippineCoinUser"
            type="button"
            class="guild-top-up-button ph-coin-top-up-button"
            :disabled="!canSubmitPhilippineCoins || !!clickPayItem"
            @click="philippineCoinTopUpClick"
          >
            <span v-if="clickPayItem" class="ph-coin-button-loading">{{ $t('recharge.paying') }}</span>
            <span v-else class="ph-coin-button-content">
              <span class="ph-coin-button-action">{{ $t('recharge.topUp') }}</span>
              <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
              <span class="original-price">{{ getCoinOriginalPrice(select_recharge_item) }}</span>
            </span>
            <PaymentDiscountBadge
              v-if="!clickPayItem"
              class="ph-coin-discount-badge"
              :label="getPaymentDiscount(select_recharge_item?.supportedPayType)"
              featured
            />
          </button>
          <button
            v-if="isGuildGemUser"
            type="button"
            class="guild-top-up-button"
            :disabled="!select_recharge_item || clickPayItem"
            @click="guildGemTopUpClick"
          >
            <span v-if="clickPayItem">{{ $t('recharge.paying') }}</span>
            <span v-else class="gem-top-up-button-content">
              <span>Top-Up Now</span>
              <span>{{ getRechargePrice(select_recharge_item) }}</span>
            </span>
          </button>
          <!-- <button 
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.stripe')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->

            <!-- <button 
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" :alt="$t('recharge.airwallex')" class="payment-icon">
                <span class="payment-text">{{ $t('recharge.airwallex') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->
          <!-- 遍历所有支持的支付方式 -->
          <div v-for="payType in visiblePayTypes" v-show="!isGuildGemUser && !isPhilippineCoinUser" :key="payType" class="payment-method">
            <!-- Stripe 支付 -->
            <button 
              v-if="(payType === 'STRIPE' || payType === 'DIANDIAN') && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.stripe')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>

            <!-- PayerMax 支付 -->
            <button 
              v-else-if="['PAYERMAX', 'PAYERMAX_QRPH'].includes(payType) && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="payermaxClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: ['PAYERMAX', 'PAYERMAX_QRPH'].includes(clickPayItem) }">
                <div v-if="['PAYERMAX', 'PAYERMAX_QRPH'].includes(clickPayItem)" class="loading-spinner"></div>
                <img src="@/img/ic_payermax.svg" :alt="$t('recharge.payermax')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYERMAX' ? $t('recharge.paying') : $t('recharge.payermax') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" featured />
            </button>

            <!-- PayPal 支付 -->
            <button 
              v-else-if="payType === 'PAYPAL' && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="customPaypalClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'PAYPAL' }">
                <div v-if="clickPayItem === 'PAYPAL'" class="loading-spinner"></div>
                <img src="@/img/ic_paypal.svg" :alt="$t('recharge.paypal')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYPAL' ? $t('recharge.paying') : $t('recharge.paypal') }}</span>
                <span class="payment-price">{{ getPaymentPrice(paypal_product_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>

            <!-- PINGPONG 支付 -->
            <button 
              v-else-if="['PINGPONG', 'PINGPONG_QRPH'].includes(payType) && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="pingpongClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: ['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem) }">
                <div v-if="['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem)" class="loading-spinner"></div>
                <img src="@/img/ic_pingpong.png" :alt="$t('recharge.pingpong')" class="pp-payment-icon">
                <!-- <span class="payment-text">{{ clickPayItem === 'PINGPONG' ? $t('recharge.paying') : $t('recharge.pingpong') }}</span> -->
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>


            <!-- DIANDIAN 支付 -->
            <!-- <button 
              v-else-if="payType === 'DIANDIAN'"
              class="payment-button"
              @click="diandianPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'DIANDIAN' }">
                <div v-if="clickPayItem === 'DIANDIAN'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.diandian')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'DIANDIAN' ? "Paying..." : "Diandian Pay" }}</span>
                <span class="payment-price">${{ select_recharge_item?.cent || '20.00' }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->

            <!-- HAIPAY_USDT 支付 -->
            <!-- <button 
              v-else-if="payType === 'HAIPAY_USDT'"
              class="payment-button"
              @click="haipayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'HAIPAY_USDT' }">
                <div v-if="clickPayItem === 'HAIPAY_USDT'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.haipay')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'HAIPAY_USDT' ? "Paying..." : "HaiPay USDT" }}</span>
                <span class="payment-price">${{ select_recharge_item?.cent || '20.00' }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->
          </div>
          <button 
              v-if="!isGuildGemUser && isPaymentMethodAvailable('AIRWALLEX')"
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" :alt="$t('recharge.airwallex')" class="payment-icon">
                <span class="payment-text">{{ $t('recharge.airwallex') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount('AIRWALLEX')" />
            </button>
        </div>
      </div>
    </div>

    <!-- 加载遮罩 -->
    <div class="loading-overlay" v-if="loading">
      <div class="loader"></div>
      <span>{{ $t('recharge.coinsAreBeingDistributed') }}</span>
    </div>

    <RechargeResultModal
      :result="rechargeResult"
      @close="closeRechargeResult"
    />
  </div>
</template>

<script setup>
import router from '#/router'
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useOumiRecharge } from '../composables/useOumiRecharge'
import PaymentDiscountBadge from './PaymentDiscountBadge.vue'
import RechargeTypeTabs from './RechargeTypeTabs.vue'
import RechargeResultModal from './RechargeResultModal.vue'
import coinIcon from '@/img/recharge/oumi_coin.webp'
import gemIcon from '@/img/gem/gem_icon.webp'

const {
  loading,
  select_recharge_id,
  select_recharge_item,
  paypal_product_item,
  recharge_list,
  supportedPayTypes,
  user,
  user_id,
  isNewUser,
  clickPayItem,
  rechargeResult,
  activeRechargeType,
  gemRechargeAllowed,
  rechargeOptionsLoading,
  showRechargeOptions,
  showPaymentOptions,
  isGuildGemUser,
  isPhilippineCoinUser,
  canSubmitPhilippineCoins,
  philippineCoinTopUpClick,
  isPaymentMethodAvailable,
  getPaymentDiscount,
  getPaymentPrice,
  getCoinOriginalPrice,
  getRechargeAmount,
  getRechargePrice,
  airwallexPayClick,
  priceChangeHandle,
  checkUid,
  saveUid,
  clearUserInput,
  closeRechargeResult,
  switchRechargeType,
  guildGemTopUpClick,
  stripePayClick,
  payermaxClick,
  diandianPayClick,
  pingpongClick,
  customPaypalClick,
  haipayClick,
} = useOumiRecharge()

const renderedPayTypes = [
  'STRIPE',
  'DIANDIAN',
  'PAYERMAX',
  'PAYERMAX_QRPH',
  'PAYPAL',
  'PINGPONG',
  'PINGPONG_QRPH',
]
const visiblePayTypes = computed(() => (
  supportedPayTypes.value.filter(payType => (
    renderedPayTypes.includes(payType) && isPaymentMethodAvailable(payType)
  ))
))

function goHome() {
  router.push('/')
}

onMounted(() => {
  document.documentElement.classList.add('oumi-recharge-mobile-root')
  document.body.classList.add('oumi-recharge-mobile-root')
})

onBeforeUnmount(() => {
  document.documentElement.classList.remove('oumi-recharge-mobile-root')
  document.body.classList.remove('oumi-recharge-mobile-root')
})
</script>

<style lang='scss' scoped>
:global(.oumi-recharge-mobile-root) {
  background: #000000;
  overscroll-behavior: none;
}

:global(body.oumi-recharge-mobile-root),
:global(html.oumi-recharge-mobile-root) {
  min-height: 100%;
}

:global(.oumi-recharge-mobile-root #app),
:global(.oumi-recharge-mobile-root .main-content) {
  background: #000000;
}

.recharge-page {
  width: 100%;
  min-height: 100vh;
  background:
    url('@/img/recharge/oumi_recharge_top_bg.webp') no-repeat top center / 100% auto,
    url('@/img/recharge/oumi_recharge_bottom_bg.webp') no-repeat bottom center / 100% auto,
    #000000;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
  box-sizing: border-box;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Poppins', sans-serif;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.mobile-recharge-header {
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  flex: 0 0 auto;

  .mobile-header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 16px;
  }

  .mobile-logo-section {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .mobile-logo-icon {
    width: 90px;
    height: 28px;
    object-fit: cover;
    border-radius: 8px;
  }
}

.recharge-container {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;

  .coin-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .page-title {
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    font-family: inherit;
  }
}

.recharge-card {
  width: 100%;
  background-size: cover;
  border-radius: 24px;
  padding: 40px 48px;
  position: relative;
  overflow: hidden;
  
}

.gem-mode .original-price {
  display: none;
}

.option-skeleton {
  pointer-events: none;
  border-color: transparent !important;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.16) 50%,
    rgba(255, 255, 255, 0.08) 75%
  ) !important;
  background-size: 200% 100% !important;
  animation: option-shimmer 1.2s linear infinite;
}

.gem-mode .coin-option.disabled {
  cursor: not-allowed;
  opacity: 0.42;
  filter: grayscale(0.4);
  border-color: rgba(255, 255, 255, 0.14);
  box-shadow: none;
}

@keyframes option-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

.input-section-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  background: #1A1A1A;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  overflow: hidden;

  .input-section-card {
    width: 100%;
    background: #1824B6;
    min-height: 96px;
    border-radius: 0;
    padding: 12px 16px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;

    .card-copy {
      min-width: 0;
      max-width: 480px;
    }

    .card-title {
      font-weight: 900;
      font-size: clamp(16px, 4.4vw, 18px);
      line-height: 1.2;
      text-transform: uppercase;
      color: #FBEB03;
    }
    .card-description {
      margin-top: 4px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #FFFFFF;
      overflow-wrap: break-word;
    }
    .gift-icon {
      display: block;
      width: clamp(76px, 20vw, 104px);
      height: auto;
      object-fit: contain;
    }
  }
}

.currency-tabs {
  flex: 0 0 auto;
  margin: 8px auto 20px;
}

.user-id-title {
  display: block;
  margin: 0 0 10px;
  color: rgba(255, 255, 255, 0.72);
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
}

.input-section {
  width: 100%;
  border-radius: 0;
  padding: 14px;
  background: #1A1A1A;
  position: relative;
  z-index: 1;

  .input-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 12px;
    font-family: inherit;
    text-align: center;
  }

  .input-wrapper {
    position: relative;
    width: 100%;
  }

  .user-input {
    width: 100%;
    height: 48px;
    padding: 16px 42px 16px 16px;
    background: transparent;
    border: 1px solid #FFFFFF1F;
    border-radius: 12px;
    font-family: inherit;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    color: #ffffff;
    caret-color: #FDF652;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &::placeholder {
      color: #FFFFFF5C;
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border: 1px solid #FFFFFF;
      background: #00000080;
    }
  }

  .clear-input-button {
    position: absolute;
    top: 50%;
    right: 16px;
    width: 14px;
    height: 14px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #FFFFFF5C;
    cursor: pointer;
    transform: translateY(-50%);

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8px;
      height: 2px;
      border-radius: 1px;
      background: #000000;
      transform-origin: center;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    .user-avatar {
      width: 32px;
      height: 32px;
      margin-right: 10px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid #FFFFFF1F;
    }

    .user-details {
      margin-right: 8px;
      .user-name {
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
      }

      .user-uid {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .first-top-up {
      background: rgba(253, 246, 82, 0.1);
      width: 72px;
      height: 20px;
      border-radius: 4px;
      line-height: 20px;
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      color: #FBEB03;
    }
  }
}

.amount-section {
  margin-bottom: 32px;

  .section-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 12px;
    font-family: inherit;
    text-align: left;
  }

  .coin-options {
    display: grid;
    grid-template-columns: repeat(auto-fit, 108px);
    gap: 10px;
    justify-content: center;
    justify-items: center;
  }

  .coin-option {
    width: 108px;
    height: 84px;
    background: #1A1A1A;
    border: 1px solid transparent;
    border-radius: 24px;
    padding: 0;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #1A1A1A;
      border-color: rgba(253, 246, 82, 0.5);
    }

    &.active {
      background: rgba(253, 246, 82, 0.15);
      border-color: #FDF652;
      box-shadow: 0 0 20px rgba(253, 246, 82, 0.3);
    }

    .coin-amount {
      max-width: 100%;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-family: 'DIN Alternate', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Poppins', sans-serif;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      color: #ffffff;
      margin: 0;
      text-align: center;
      line-height: 26px;
      white-space: nowrap;

      .coin-icon-small {
        flex: 0 0 20px;
        width: 20px;
        height: 20px;
      }

      &.coin-amount-long {
        gap: 4px;
        font-size: 18px;

        .coin-icon-small {
          flex-basis: 18px;
          width: 18px;
          height: 18px;
        }
      }
    }

    .coin-label {
      font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Poppins', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      line-height: 17px;
    }
  }
}

.payment-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .payment-method {
    width: 100%;
  }

  .payment-button {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
    background: #ffffff;
    border: none;
    border-radius: 24px;
    height: 48px;
    padding: 0 24px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    font-family: inherit;
    box-shadow: none;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 1;
      cursor: not-allowed;
    }

    .button-content {
      width: 100%;
      min-width: 0;
      display: grid;
      grid-template-columns: 28px minmax(0, 1fr) max-content max-content;
      align-items: center;
      justify-content: center;
      gap: 12px;
      position: relative;

      &.loading {
        opacity: 0.7;
      }

      .loading-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid #333333;
        border-top: 2px solid transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      .payment-icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }

      .pp-payment-icon {
        justify-self: start;
        width: 124px;
        max-width: 124px;
        height: 28px;
        grid-column: 1 / 3;
        object-fit: contain;
        object-position: left center;
      }

      .payment-text {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        color: #111111;
        line-height: 1.1;
        text-align: left;
        white-space: nowrap;
      }

      .payment-price {
        font-size: 14px;
        font-weight: 600;
        color: #111111;
        white-space: nowrap;
      }

      .original-price {
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 0.3);
        text-decoration: line-through;
        margin-left: 0;
        white-space: nowrap;
      }
    }
  }
}

.guild-top-up-button {
  width: 100%;
  height: 54px;
  padding: 0;
  border: 0;
  border-radius: 27px;
  color: #111111;
  background: #FDF652;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}

.gem-top-up-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  white-space: nowrap;
}

.ph-coin-top-up-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(105deg, #fff86a 0%, #ffe24b 100%);
  box-shadow: 0 7px 20px rgba(255, 226, 75, 0.2);
  transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(1.025);
    box-shadow: 0 9px 24px rgba(255, 226, 75, 0.28);
    transform: translateY(-1px);
  }

  &:disabled {
    box-shadow: none;
  }
}

.ph-coin-discount-badge {
  top: -10px !important;
  right: 10px !important;
}

.ph-coin-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-top: 3px;
}

.ph-coin-button-action {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.ph-coin-button-content .payment-price,
.ph-coin-button-content .original-price {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.ph-coin-button-content .original-price {
  color: rgba(51, 51, 51, 0.4);
  text-decoration: line-through;
}

.ph-coin-top-up-hint {
  margin-top: -2px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #FDF652;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 响应式设计
@media (max-width: 900px) {
  .recharge-page {
    padding: 0;
  }

  .recharge-container {
    max-width: 100%;
    padding: 0 16px 32px 16px;
  }

  .page-header {
    .coin-icon {
      width: 32px;
      height: 32px;
    }

    .page-title {
      font-size: 24px;
    }
  }

  .recharge-card {
    padding: 24px 20px;
  }

  .coin-option {
    width: 108px;
    height: 84px;
    padding: 0;

    .coin-amount {
      font-size: 22px;

      .coin-icon-small {
        width: 20px;
        height: 20px;
      }
    }

    .coin-label {
      font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
  .mobile-recharge-header {
    height: 52px;

    .mobile-header-content {
      padding: 0 12px;
    }
  }

  .page-header {
    .coin-icon {
      width: 28px;
      height: 28px;
    }

    .page-title {
      font-size: 20px;
    }
  }

  .recharge-card {
    padding: 24px 16px 0;
  }

  .amount-section {
    width: calc(100vw - 32px);
    margin-left: -16px;
    margin-right: -16px;
  }

  .amount-section .coin-options {
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    justify-content: center;
  }

  .amount-section .coin-option {
    width: 100%;
    min-width: 0;
    height: 84px;
    padding: 0;
    overflow: hidden;

    .coin-amount {
      font-size: 22px;
      gap: 6px;

      .coin-icon-small {
        width: 20px;
        height: 20px;
      }
    }

    .coin-label {
      font-size: 14px;
    }
  }

  .payment-button {
    height: 48px;
    padding: 0 20px;

    .button-content {
      grid-template-columns: 24px minmax(0, 1fr) max-content max-content;
      gap: 8px;
      justify-content: stretch;

      .payment-icon {
        width: 24px;
        height: 24px;
      }

      .pp-payment-icon {
        width: 124px;
        max-width: 124px;
        height: 24px;
      }

      .payment-text {
        font-size: 14px;
        white-space: nowrap;
      }

      .payment-price {
        font-size: 14px;
      }

      .original-price {
        font-size: 12px;
      }
    }
  }

  .payment-section {
    width: calc(100vw - 32px);
    margin-left: -16px;
    margin-right: -16px;
    gap: 10px;
    margin-top: 20px;
  }
}

</style>
